import {client} from './axios';

export function getCurrentProfile() {
    return client.get('user');
};

export function refreshAuthToken() {
    return client.post('user/refresh');
}

export function generateKeyPair() {
    return client.get('user/generate-keypair');
}

export function verifyKeypair(verificationKey: string) {
    return client.post('user/verify-keypair', {
        verificationKey: verificationKey
    });
};